import { createContext } from 'react';
import type { Crumb } from './use-breadcrumbs';

/**
 * Shared state behind {@link PageCrumbsProvider}.
 *
 * Split from the provider component so that file exports only a component,
 * which is what keeps React Fast Refresh working for the whole shell.
 */
export interface PageCrumbsState {
  crumbs: Crumb[] | null;
  setCrumbs: (crumbs: Crumb[] | null) => void;
}

export const PageCrumbsCtx = createContext<PageCrumbsState | null>(null);
